import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK, DynamicSvg, getTestId, LILAC_400, TRANSPARENT, Typography, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { Image, View } from 'react-native';
import { getAdditionalBenefitsStyles } from './AdditionalBenefitsStyles';
export var AdditionalBenefitsCard = props => {
  var _a;
  var _useState = useState(TRANSPARENT),
    placeholderBgColor = _useState[0],
    setPlaceholderBgColor = _useState[1];
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var additionalBenefitsStyles = getAdditionalBenefitsStyles(props, isSmallScreen);
  var _props$additionalBene = props.additionalBenefits,
    additionalBenefits = _props$additionalBene === void 0 ? [] : _props$additionalBene,
    _props$hideOttText = props.hideOttText,
    hideOttText = _props$hideOttText === void 0 ? false : _props$hideOttText,
    _props$showAdditional = props.showAdditionalBenefits,
    showAdditionalBenefits = _props$showAdditional === void 0 ? false : _props$showAdditional,
    testID = props.testID,
    additionalBenefitContainerStyle = props.additionalBenefitContainerStyle,
    _props$alignBenefitsE = props.alignBenefitsEqually,
    alignBenefitsEqually = _props$alignBenefitsE === void 0 ? false : _props$alignBenefitsE;
  var benefitDescription = (additionalBenefits === null || additionalBenefits === void 0 ? void 0 : additionalBenefits.length) === 1 ? (_a = additionalBenefits[0]) === null || _a === void 0 ? void 0 : _a.benefitDescription : '';
  var updatedBenefits = [...additionalBenefits];
  var maxBenefitsLength = hideOttText ? 5 : 2;
  if (alignBenefitsEqually) {
    maxBenefitsLength = 3;
  }
  var updatedBenefitsLength = hideOttText ? 4 : 2;
  var hiddenBenefitsCount = 0;
  if ((additionalBenefits === null || additionalBenefits === void 0 ? void 0 : additionalBenefits.length) > maxBenefitsLength) {
    updatedBenefits.length = updatedBenefitsLength;
    hiddenBenefitsCount = (additionalBenefits === null || additionalBenefits === void 0 ? void 0 : additionalBenefits.length) - (updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length);
  }
  var getHiddenCountAccessibilityLabel = () => {
    return "+" + hiddenBenefitsCount + " benefit" + (hiddenBenefitsCount > 1 ? 's' : '');
  };
  var benefitsImagesDimensions = isSmallScreen ? {
    width: 28,
    height: 28
  } : {
    width: 32,
    height: 32
  };
  var benefitsSectionDimensions = isSmallScreen ? {
    height: 28
  } : {
    height: 32
  };
  return _jsxs(View, Object.assign({
    style: additionalBenefitsStyles.secondaryCardContainer
  }, getTestId(testID, 'additionalBenefitsWrapper'), {
    children: [!benefitDescription && ((updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length) > 0 || showAdditionalBenefits && !isSmallScreen) && _jsxs(View, Object.assign({
      style: additionalBenefitsStyles.benefitsContainer
    }, getTestId(testID, 'additionalBenefitsContainer'), {
      children: [_jsx(View, Object.assign({
        style: [additionalBenefitsStyles.ottContainer, !!alignBenefitsEqually && additionalBenefitsStyles.distributedSpacing]
      }, getTestId(testID, 'additionalBenefitsOttContainer'), {
        children: (updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length) > 0 ? updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.map((benefit, index) => {
          var _benefit$benefitUrl = benefit.benefitUrl,
            benefitUrl = _benefit$benefitUrl === void 0 ? '' : _benefit$benefitUrl,
            _benefit$benefitText = benefit.benefitText,
            benefitText = _benefit$benefitText === void 0 ? '' : _benefit$benefitText,
            _benefit$benefitIcon = benefit.benefitIcon,
            benefitIcon = _benefit$benefitIcon === void 0 ? '' : _benefit$benefitIcon,
            _benefit$accessibilit = benefit.accessibilityProps,
            accessibilityProps = _benefit$accessibilit === void 0 ? {} : _benefit$accessibilit;
          return _jsxs(View, Object.assign({
            style: additionalBenefitsStyles.ottItem
          }, {
            children: [!!benefitUrl && _jsx(Image, Object.assign({
              source: {
                uri: benefitUrl,
                width: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.width,
                height: benefitsImagesDimensions === null || benefitsImagesDimensions === void 0 ? void 0 : benefitsImagesDimensions.height
              },
              style: [additionalBenefitsStyles.benefitImage, {
                backgroundColor: placeholderBgColor
              }],
              onError: () => setPlaceholderBgColor(LILAC_400)
            }, getTestId(testID, "benefitImageWrapper"), accessibilityProps)), !!benefitIcon && _jsx(DynamicSvg, Object.assign({
              iconName: benefitIcon,
              style: additionalBenefitsStyles.icon,
              fontSize: isSmallScreen ? 32 : 40
            }, getTestId(testID, 'icon'))), !!benefitText && !hideOttText && _jsx(Typography, Object.assign({
              text: benefitText,
              type: 'body-single-line-sm',
              style: additionalBenefitsStyles.benefitText,
              numberOfLines: 1,
              ellipsizeMode: "tail"
            }, getTestId(testID, "benefitText")))]
          }), "benefit-" + index);
        }) : _jsx(View, {
          style: benefitsSectionDimensions
        })
      })), hiddenBenefitsCount > 0 && _jsx(View, Object.assign({
        style: [additionalBenefitsStyles.hiddenBenefitsCountContainer, additionalBenefitContainerStyle]
      }, getTestId(testID, "hiddenBenefitTextWrapper"), {
        children: _jsx(Typography, Object.assign({
          text: "+" + hiddenBenefitsCount,
          type: "body-single-line-xs",
          color: BLACK,
          accessibilityLabel: getHiddenCountAccessibilityLabel()
        }, getTestId(testID, "hiddenBenefitText")))
      }))]
    })), !!benefitDescription && _jsx(View, Object.assign({
      style: additionalBenefitsStyles.descriptionText
    }, getTestId(testID, "benefitDescriptionTextWrapper"), {
      children: _jsx(Typography, Object.assign({
        type: "body-para-xs",
        text: benefitDescription,
        numberOfLines: 2
      }, getTestId(testID, "benefitDescriptionText")))
    }))]
  }));
};